/**
 * Recently Viewed Vanilla Carousel
 * Replaces Slick carousel with vanilla JavaScript implementation
 */

// The arrow images sit beside this file in the theme's assets. They were hardcoded to
// the assets folder of theme t/106, since deleted: both 404'd and the buttons showed
// their alt text clipped to "PR" / "NE" (A, 2026-09-26).
var agrvAssetBase = (function () {
  var s = document.currentScript || document.querySelector('script[src*="recently-viewed-carousel.js"]');
  return s && s.src ? s.src.split('?')[0].replace(/[^\/]+$/, '') : '';
})();

window.RecentlyViewedCarousel = {
  initialize: function(grid) {
    if (!grid || grid.children.length === 0) {
      console.warn('⚠️ No products to show in recently viewed');
      return;
    }

    // Remove any existing carousel classes from grid
    grid.classList.remove('carousel-container', 'carousel-initialized');
    
    // Clear any existing carousel structure
    const existingTrack = grid.querySelector('.carousel-track');
    if (existingTrack) {
      // Move items back to grid
      while (existingTrack.firstChild) {
        grid.appendChild(existingTrack.firstChild);
      }
      existingTrack.remove();
    }
    
    // Remove existing carousel container and arrows
    const existingCarouselContainer = grid.parentElement.querySelector('.carousel-container');
    if (existingCarouselContainer) {
      // Move items back to grid before removing container
      const existingItems = existingCarouselContainer.querySelectorAll('.carousel-slide');
      existingItems.forEach(slide => {
        if (slide.firstChild) {
          grid.appendChild(slide.firstChild);
        }
      });
      existingCarouselContainer.remove();
    }
    
    // Get all product cards
    const items = Array.from(grid.children);
    if (items.length === 0) return;
    
    console.log('🎠 Initializing vanilla carousel with', items.length, 'items');
    
    // Create new carousel container div inside the grid
    const carouselContainer = document.createElement('div');
    carouselContainer.className = 'carousel-container carousel-initialized';
    
    // Add carousel container inside the grid
    grid.appendChild(carouselContainer);
    
    // Create carousel structure
    const track = document.createElement('div');
    track.className = 'carousel-track';
    
    // Wrap items in slides
    items.forEach((item, index) => {
      const slide = document.createElement('div');
      slide.className = 'carousel-slide';
      slide.appendChild(item);
      track.appendChild(slide);
    });
    
    // Add track to carousel container
    carouselContainer.appendChild(track);
    
    // Add navigation arrows outside the carousel container (in their previous position)
    const prevBtn = document.createElement('button');
    prevBtn.className = 'carousel-btn carousel-arrow carousel-prev';
    prevBtn.innerHTML = '<img loading="lazy" src="' + agrvAssetBase + 'new-left-arrow.svg" alt="Previous" width="50" height="50" decoding="async">';
    prevBtn.setAttribute('aria-label', 'Previous products');
    
    const nextBtn = document.createElement('button');
    nextBtn.className = 'carousel-btn carousel-arrow carousel-next';
    nextBtn.innerHTML = '<img loading="lazy" src="' + agrvAssetBase + 'new-right-arrow.svg" alt="Next" width="50" height="50" decoding="async">';
    nextBtn.setAttribute('aria-label', 'Next products');
    
    // Add buttons inside the grid (after the carousel container)
    grid.insertAdjacentHTML('beforeend', '<div class="carousel-scroll"><span class="scroll-indicator"></span></div>');

    grid.appendChild(prevBtn);
    grid.appendChild(nextBtn);

    // Initialize carousel functionality
    this.initCarouselFunctionality(carouselContainer, track, items.length);

    // R14 (2026-05-03): position prev/next vertically on the first card's
    // image center via shared category-tabbings-arrows.js. Buttons + cards
    // were just inserted into the DOM, so the shared script's automatic
    // DOMContentLoaded run already happened (and found no recently-viewed
    // grid populated yet). Call positionAll() explicitly now that the DOM
    // is ready. requestAnimationFrame ensures the just-inserted elements
    // have a layout (bounding box) before we measure.
    if (window.AGCarouselArrows && window.AGCarouselArrows.positionAll) {
      requestAnimationFrame(function () { window.AGCarouselArrows.positionAll(); });
    }

    console.log('✅ Recently viewed vanilla carousel initialized');
  },

  initCarouselFunctionality: function(container, track, totalItems) {
    // R1 (2026-05-03, home-page Phase 2): paged navigation by Math.floor(itemsPerView).
    // Was advance-by-1 (smooth/continuous); now advance-by-pageStep so click-next at
    // 4.5 visible advances 4 cards, peek refreshes from next batch.
    // pageStep + maxIndex are `let` so resize can reassign them.
    let currentIndex = 0;
    let itemsPerView = this.getItemsPerView();
    let pageStep = Math.floor(itemsPerView);
    let maxIndex = Math.max(0, totalItems - pageStep);

    if(totalItems <= 5){
      container.parentElement.classList.add('total-slide-'+totalItems);
    }


    const updateCarousel = () => {
      const slideWidth = 100 / itemsPerView;
      const translateX = -currentIndex * slideWidth;
      track.style.transform = `translateX(${translateX}%)`;

      // Update button states - buttons are now inside the grid
      const prevBtn = container.parentElement.querySelector('.carousel-prev');
      const nextBtn = container.parentElement.querySelector('.carousel-next');

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    };

    const nextSlide = () => {
      if (currentIndex < maxIndex) {
        currentIndex = Math.min(maxIndex, currentIndex + pageStep);
        updateCarousel();
      }
    };

    const prevSlide = () => {
      if (currentIndex > 0) {
        currentIndex = Math.max(0, currentIndex - pageStep);
        updateCarousel();
      }
    };
    
    // Add event listeners - buttons are now inside the grid

    const scrollBar = container.parentElement.querySelector('.carousel-scroll');
    const indicator = container.parentElement.querySelector('.scroll-indicator');

    const nextBtn = container.parentElement.querySelector('.carousel-next');
    const prevBtn = container.parentElement.querySelector('.carousel-prev');
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        nextSlide();
        updateCarouselPosition();
      });
    }
    
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        prevSlide();
        updateCarouselPosition();
      });
    }

    updateCarouselPosition();
    scrollBar.addEventListener('click', function (e) {

      const trackRect = scrollBar.getBoundingClientRect();
      const indicatorRect = indicator.getBoundingClientRect();
      const clickX = e.clientX;
      const indicatorLeft = indicatorRect.left;
      const indicatorRight = indicatorRect.right;

      if (clickX < indicatorLeft) {
        currentIndex = Math.max(0, currentIndex - pageStep);
        updateCarouselPosition();
      } else if (clickX > indicatorRight) {
        currentIndex = Math.min(maxIndex, currentIndex + pageStep);
        updateCarouselPosition();
      }

    });

    function getItemsPerView() {
      // R1 (2026-05-03, home-page Phase 2): peek-the-5th at >1200px.
      // 4.5 visible = 4 full + half-card peek; matches CSS .carousel-slide width: calc(100%/4.5).
      // Pagination steps by Math.floor (4) — see pageStep below.
      const w = window.innerWidth;
      if (w <= 768) return 2;    // matches CSS @media (max-width: 768px) -> 50% width
      if (w <= 1200) return 3;   // matches CSS @media (max-width: 1200px) -> 33.333% width
      return 4.5;                 // matches CSS default -> calc(100%/4.5) width
    }

    function updateCarouselPosition() {
      const itemsPerView = getItemsPerView();
      const localPageStep = Math.floor(itemsPerView);
      const itemWidth = 100 / itemsPerView; // Percentage of TRACK width per card (visible math, can be fractional)
      const translateX = -(currentIndex * itemWidth);

      track.style.transform = `translateX(${translateX}%)`;
      track.style.transition = 'transform 0.3s ease';

      // R1.1 (2026-05-03): scroll-indicator math uses pageStep (integer) instead of
      // itemsPerView (fractional) so the indicator represents pages cleanly. Width =
      // (pageStep/totalItems)*100 = page coverage; translateX = (currentIndex/pageStep)*100
      // = move 100% of own width per page. Right edge maxes at exactly 100% on last page.
      const indicatorWidthPercent = (localPageStep / totalItems) * 100;
      const indicatorTranslatePercent = localPageStep > 0 ? (currentIndex / localPageStep) * 100 : 0;
      indicator.style.width = indicatorWidthPercent + "%";
      indicator.style.transform = `translateX(${indicatorTranslatePercent}%)`;

      // Update button states
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
      }

      if (nextBtn) {
        nextBtn.disabled = currentIndex >= maxIndex;
        nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
      }
    }

    let isDraggingIndicator = false;
    let startX1 = 0;

    indicator.addEventListener('mousedown', function (e) {
      isDraggingIndicator = true;
      startX1 = e.clientX;
      indicator.style.cursor = 'grabbing';
      e.stopPropagation();
    });

    document.addEventListener('mouseup', function () {
      isDraggingIndicator = false;
      indicator.style.cursor = 'grab';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDraggingIndicator) return;

      const scrollRect = scrollBar.getBoundingClientRect();
      const localItemsPerView = getItemsPerView();
      const localMaxIndex = totalItems - Math.floor(localItemsPerView);
      const trackWidth = scrollBar.clientWidth;
      const indicatorWidth = indicator.clientWidth;

      let relativeX = e.clientX - scrollRect.left - (indicatorWidth / 2);
      relativeX = Math.max(0, Math.min(relativeX, trackWidth - indicatorWidth));
      const percent = relativeX / (trackWidth - indicatorWidth);
      currentIndex = Math.round(percent * localMaxIndex);
      updateCarouselPosition();
    });
    
    // Handle window resize — reassign outer pageStep + maxIndex so all
    // navigation handlers (click + scrollBar + nextSlide/prevSlide) see
    // the new viewport's values.
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newItemsPerView = this.getItemsPerView();
        if (newItemsPerView !== itemsPerView) {
          itemsPerView = newItemsPerView;
          pageStep = Math.floor(itemsPerView);
          maxIndex = Math.max(0, totalItems - pageStep);
          // Adjust current index if needed
          if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
          }
          updateCarousel();
        }
        updateCarouselPosition();
      }, 250);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Touch/swipe support
    let startX = 0;
    let isDragging = false;
    
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    });
    
    track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });
    
    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) { // Minimum swipe distance
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
      updateCarouselPosition();
    });
    
    // Mouse drag support for desktop
    let mouseStartX = 0;
    let isMouseDragging = false;
    
    track.addEventListener('mousedown', (e) => {
      mouseStartX = e.clientX;
      isMouseDragging = true;
      track.style.cursor = 'grabbing';
    });
    
    track.addEventListener('mousemove', (e) => {
      if (!isMouseDragging) return;
      e.preventDefault();
      updateCarouselPosition();
    });
    
    track.addEventListener('mouseup', (e) => {
      if (!isMouseDragging) return;
      isMouseDragging = false;
      track.style.cursor = 'grab';
      
      const mouseEndX = e.clientX;
      const mouseDiff = mouseStartX - mouseEndX;
      
      if (Math.abs(mouseDiff) > 50) { // Minimum drag distance
        if (mouseDiff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    });
    
    track.addEventListener('mouseleave', () => {
      isMouseDragging = false;
      track.style.cursor = 'grab';
    });
    
    // Initialize
    updateCarousel();
  },

  getItemsPerView: function() {
    // R1 (2026-05-03, home-page Phase 2): peek-the-5th at >1200px.
    // 4.5 visible = 4 full + half-card peek; matches CSS .carousel-slide width: calc(100%/4.5).
    // Mirrors the local getItemsPerView() inside initCarouselFunctionality (kept in sync).
    const width = window.innerWidth;
    if (width <= 768) return 2;    // matches CSS @media (max-width: 768px) -> 50% width
    if (width <= 1200) return 3;   // matches CSS @media (max-width: 1200px) -> 33.333% width
    return 4.5;                     // matches CSS default -> calc(100%/4.5) width
  }
};
